export enum DateTimeFormat {
  AMERICAN = 'MM-dd-yyyy HH:mm:ss', // American format with hyphens
  EUROPEAN = 'dd-MM-yyyy HH:mm:ss', // European format with hyphens
  STANDARD = 'yyyy-MM-dd HH:mm:ss', // Standard / ISO
}

export const dateTimeFormatWithoutSeconds = (format: string): string => {
  if (format === DateTimeFormat.AMERICAN) {
    return 'MM-dd-yyyy HH:mm';
  } else if (format === DateTimeFormat.EUROPEAN) {
    return 'dd-MM-yyyy HH:mm';
  } else if (format === DateTimeFormat.STANDARD) {
    return 'yyyy-MM-dd HH:mm';
  } else {
    throw Error('Invalid DateTimeFormat');
  }
};
